/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Re_RankingInputs */

const en_svchip_re_ranking = /** @type {(inputs: Svchip_Re_RankingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Re-ranking`)
};

const ar_svchip_re_ranking = /** @type {(inputs: Svchip_Re_RankingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إعادة الترتيب`)
};

const bn_svchip_re_ranking = /** @type {(inputs: Svchip_Re_RankingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রি-র্যাংকিং`)
};

const de_svchip_re_ranking = /** @type {(inputs: Svchip_Re_RankingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neubewertung`)
};

const es_svchip_re_ranking = /** @type {(inputs: Svchip_Re_RankingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reclasificación`)
};

const fr_svchip_re_ranking = /** @type {(inputs: Svchip_Re_RankingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reclassement`)
};

const pt_svchip_re_ranking = /** @type {(inputs: Svchip_Re_RankingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reclassificação`)
};

const zh_svchip_re_ranking = /** @type {(inputs: Svchip_Re_RankingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重新排名`)
};

const tr_svchip_re_ranking = /** @type {(inputs: Svchip_Re_RankingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeniden sıralama`)
};

const ru_svchip_re_ranking = /** @type {(inputs: Svchip_Re_RankingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменение рейтинга`)
};

const pl_svchip_re_ranking = /** @type {(inputs: Svchip_Re_RankingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ponowna klasyfikacja`)
};

/**
* | output |
* | --- |
* | "Re-ranking" |
*
* @param {Svchip_Re_RankingInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_re_ranking = /** @type {((inputs?: Svchip_Re_RankingInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Re_RankingInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_re_ranking(inputs)
	if (locale === "bn") return bn_svchip_re_ranking(inputs)
	if (locale === "de") return de_svchip_re_ranking(inputs)
	if (locale === "es") return es_svchip_re_ranking(inputs)
	if (locale === "fr") return fr_svchip_re_ranking(inputs)
	if (locale === "pt") return pt_svchip_re_ranking(inputs)
	if (locale === "zh") return zh_svchip_re_ranking(inputs)
	if (locale === "tr") return tr_svchip_re_ranking(inputs)
	if (locale === "ru") return ru_svchip_re_ranking(inputs)
	if (locale === "pl") return pl_svchip_re_ranking(inputs)
	return en_svchip_re_ranking(inputs)
});